let currency = {
  currentCurr: "₱",
  Currecy: [],
  status: false,
  value: 1,
  precision: 2,
  id: 150,
  abbreviation: "PH",
  numberFormat: "en-PH",
};
const changeCurrReducer = (state = currency, action) => {
  console.log(
    action,
    "inside change currency inside app layout change currency reducer",
    state
  );
  switch (action.type) {
    case "CHANGE_CURR":
      return {
        ...state,
        currentCurr: action.curr,
        value: action.value,
        precision: action.precision,
        id: action.id,
        numberFormat:
          action.curr == "BHD"
            ? "ar-BH"
            : action.curr == "USD"
            ? "en-US"
            : action.curr == "ZAR"
            ? "en-ZA"
            : "en-PH",
      };
    case "CHANGE_CURR_STATUS":
      return { ...state, status: action.status };
    case "ADD_CURR":
      return {
        ...state,
        Currecy: action.curr,
        numberFormat:
          action.curr == "BHD"
            ? "ar-BH"
            : action.curr == "USD"
            ? "en-US"
            : action.curr == "ZAR"
            ? "en-ZA"
            : "en-PH",
      };
    default:
      return state;
  }
};

export default changeCurrReducer;
